import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresGeotechDataModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresGeotechDataModel._instance == null) FacePressuresGeotechDataModel._instance = new FacePressuresGeotechDataModel(authManager);
        return FacePressuresGeotechDataModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-geotech-data');

        this.entityName = 'face-pressures.FacePressuresGeotechData';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'J S Result';
        this.setLabel = 'J S Results';

        this.browser = {
            name: 'default-face-pressures-facepressuresgeotechdata-browser',
            moduleName: 'default-face-pressures-facepressuresgeotechdata-browser',
            moduleTitle: 'J S Results',
            moduleStateSlotName: 'default-face-pressures-facepressuresgeotechdata-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressuresgeotechdata-editor',
            moduleName: 'default-face-pressures-facepressuresgeotechdata-editor',
            moduleTitle: 'J S Result',
            moduleStateSlotName: 'default-face-pressures-facepressuresgeotechdata-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'FacePressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: false,
                label: 'Model Section',
                description: 'only for info (check)',
                readOnly: true,
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: false,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
                readOnly: true,
            },
            {
                name: 'elevationOfZeroDatumLevel',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Elevation Of Zero Datum Level',
                readOnly: true,
            },
            {
                name: 'objectTbmId',
                type: 'GeoObjectTbm',
                persistent: true,
                label: 'TBM Object',
            },
            {
                name: 'tbmAxisElevation',
                type: 'float',
                persistent: false,
                unit: 'masl',
                label: 'Tbm Axis Elevation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmExcavationDiameter',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Tbm Excavation Diameter',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmSlope',
                type: 'float',
                persistent: false,
                unit: '%',
                label: 'Tbm Slope',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceAngle',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Tunnel Face Angle',
                description: 'angle of tunnel face from vertical +into soil, - into tunnel; počítá se ze sklonu tunelu jako kolmice na osu tunelu',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmElevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmElevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmLevelTop',
                type: 'float',
                persistent: true,
                unit: 'm',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tbmLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'm',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'siloElevationTop',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Silo Elevation Top',
                description: '= Surface Elevation',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'siloElevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Silo Elevation Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'siloVerticalLevelTop',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Silo Vertical Level Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'siloVerticalLevelBottom',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Silo Vertical Level Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'overburden',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Overburden',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'slidingWedgeElevationBottom',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Sliding Wedge Elevation Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'slidingWedgeHeight',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Sliding Wedge Height',
                description: 'to samé jako tbm excavation diameter',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'hwCrown',
                type: 'float',
                persistent: true,
                unit: 'm',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'k1CalcMethodId',
                type: 'K1CalculationMethod',
                persistent: false,
                label: 'K 1 Calc Method',
                description: 'coefficient of lateral earth pressure within silo',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'k2CalcMethodId',
                type: 'K2CalculationMethod',
                persistent: false,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'trCalcMethodId',
                type: 'TrCalculationMethod',
                persistent: false,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'unitWeightSoilGama1Average',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Soil Gama 1 Average',
                description: 'average unit weight of soil in silo',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'cohesion1Average',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'internalFrictionAngle1Average',
                type: 'float',
                persistent: true,
                unit: 'deg',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightSoilGama1MinAverage',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Soil Gama 1 Min Average',
                description: 'udělat tak, aby se gama,min of soil in front of TBM počítalo z datasetu nazvaného minimum gama s tím, že se projdou všechny intervaly před TBM a vypúočte se průměr nad jejich hodnotami z datasetu minimum gama. Zařídit, aby uživatel mohl změnit název/referenci na dataset s minimálními hodnotami gama. Bude obecně použitelné pro většinu parametrů v geoTypech apod. + max. hodnoty apod.',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightWaterGamaW1Average',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Water Gama W 1 Average',
                description: 'average unit weight of water above TBM',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightSoilGama2Average',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Soil Gama 2 Average',
                description: 'average unit weight of soil in sliding wedge',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'cohesion2Average',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'internalFrictionAngle2Average',
                type: 'float',
                persistent: true,
                unit: 'deg',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'k02Average',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'K 02 Average',
                description: 'average coefficient of side pressure at rest K0 in sliding wedge',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'ka2Average',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Ka 2 Average',
                description: 'average coefficient of active side pressure Ka in sliding wedge',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'k1Average',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'K 1 Average',
                description: 'Average Coefficient Of Lateral Pressure K',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'k2Average',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'K 2 Average',
                description: 'Average Coefficient Of Side Pressure K',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightWaterGamaW2Average',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Water Gama W 2 Average',
                description: 'average unit weight of water in front of TBM',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'unitWeightSoilGama2MinAverage',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Unit Weight Soil Gama 2 Min Average',
                description: 'udělat tak, aby se gama,min of soil in front of TBM počítalo z datasetu nazvaného minimum gama s tím, že se projdou všechny intervaly před TBM a vypúočte se průměr nad jejich hodnotami z datasetu minimum gama. Zařídit, aby uživatel mohl změnit název/referenci na dataset s minimálními hodnotami gama. Bude obecně použitelné pro většinu parametrů v geoTypech apod. + max. hodnoty apod.',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'maximumAllowableFacePressureSafetyFactor',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Maximum Allowable Face Pressure Safety Factor',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
